'use client';

import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '@/services/api';
import { ActivePromotion } from '@/types/Promotion';

type PromotionsContextProps = {
  promotions: ActivePromotion[];
};

export const PromotionsContext = createContext<PromotionsContextProps>({
  promotions: [],
});

export const PromotionsProvider = ({ children }: { children: React.ReactNode }) => {
  const [promotions, setPromotions] = useState<ActivePromotion[]>([]);

  const fetchPromotions = useCallback(async () => {
    try {
      const response = await api.get('/promotions');
      setPromotions(response.data);
    } catch {
      // fail silently — promotions are a UI enhancement, not critical
    }
  }, []);

  useEffect(() => {
    fetchPromotions();
  }, [fetchPromotions]);

  return (
    <PromotionsContext.Provider value={{ promotions }}>
      {children}
    </PromotionsContext.Provider>
  );
};

export const usePromotions = () => useContext(PromotionsContext);
